import React, {Component} from 'react';
import {Card, CardBody, CardHeader, Collapse} from "reactstrap";

class PostpaidCustomerDetail extends Component {

	constructor(props) {
		super (props);

		this.state = {
			openedCollapses: []
		};

	}

	// with this function we create an array with the opened collapses
	// it is like a toggle function for all collapses from this page
	collapsesToggle = collapse => {
		let openedCollapses = this.state.openedCollapses;
		if (openedCollapses.includes(collapse)) {
			this.setState({
				openedCollapses: openedCollapses.filter(item => item !== collapse)
			});
		} else {
			openedCollapses.push(collapse);
			this.setState({
				openedCollapses: openedCollapses
			});
		}
	};

	render () {
		return (
			<div
				aria-multiselectable={true}
				className="card-collapse"
				id="accordion"
				role="tablist"
			>
				<Card className="card-plain">
					<CardHeader role="tab">
						<a
							aria-expanded={this.state.openedCollapses.includes(
								"collapseOne"
							)}
							href="#pablo"
							data-parent="#accordion"
							data-toggle="collapse"
							onClick={(e) => {e.preventDefault();this.collapsesToggle("collapseOne")}}
						>
							Collapsible Group Item #1{" "}
							<i className="nc-icon nc-minimal-down" />
						</a>
					</CardHeader>
					<Collapse
						role="tabpanel"
						isOpen={this.state.openedCollapses.includes("collapseOne")}
					>
						<CardBody>
							Anim pariatur cliche reprehenderit, enim eiusmod high life
							accusamus terry richardson ad squid. 3 wolf moon officia aute,
							non cupidatat skateboard dolor brunch. Food truck quinoa
							nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua
							put a bird on it squid single-origin coffee nulla assumenda
							shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
							wes anderson cred nesciunt sapiente ea proident. Ad vegan
							excepteur butcher vice lomo. Leggings occaecat craft beer
							farm-to-table, raw denim aesthetic synth nesciunt you probably
							haven't heard of them accusamus labore sustainable VHS.
						</CardBody>
					</Collapse>
				</Card>
				<Card className="card-plain">
					<CardHeader role="tab">
						<a
							aria-expanded={this.state.openedCollapses.includes(
								"collapseTwo"
							)}
							href="#pablo"
							data-parent="#accordion"
							data-toggle="collapse"
							onClick={(e) => {e.preventDefault();this.collapsesToggle("collapseTwo")}}
						>
							Collapsible Group Item #2{" "}
							<i className="nc-icon nc-minimal-down" />
						</a>
					</CardHeader>
					<Collapse
						role="tabpanel"
						isOpen={this.state.openedCollapses.includes("collapseTwo")}
					>
						<CardBody>
							Anim pariatur cliche reprehenderit, enim eiusmod high life
							accusamus terry richardson ad squid. 3 wolf moon officia aute,
							non cupidatat skateboard dolor brunch. Food truck quinoa
							nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua
							put a bird on it squid single-origin coffee nulla assumenda
							shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
							wes anderson cred nesciunt sapiente ea proident. Ad vegan
							excepteur butcher vice lomo. Leggings occaecat craft beer
							farm-to-table, raw denim aesthetic synth nesciunt you probably
							haven't heard of them accusamus labore sustainable VHS.
						</CardBody>
					</Collapse>
				</Card>
				<Card className="card-plain">
					<CardHeader role="tab">
						<a
							aria-expanded={this.state.openedCollapses.includes(
								"collapseThree"
							)}
							href="#pablo"
							data-parent="#accordion"
							data-toggle="collapse"
							onClick={(e) => {e.preventDefault();this.collapsesToggle("collapseThree")}}
						>
							Collapsible Group Item #3{" "}
							<i className="nc-icon nc-minimal-down" />
						</a>
					</CardHeader>
					<Collapse
						role="tabpanel"
						isOpen={this.state.openedCollapses.includes("collapseThree")}
					>
						<CardBody>
							Anim pariatur cliche reprehenderit, enim eiusmod high life
							accusamus terry richardson ad squid. 3 wolf moon officia aute,
							non cupidatat skateboard dolor brunch. Food truck quinoa
							nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua
							put a bird on it squid single-origin coffee nulla assumenda
							shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
							wes anderson cred nesciunt sapiente ea proident. Ad vegan
							excepteur butcher vice lomo. Leggings occaecat craft beer
							farm-to-table, raw denim aesthetic synth nesciunt you probably
							haven't heard of them accusamus labore sustainable VHS.
						</CardBody>
					</Collapse>
				</Card>
			</div>
		)
	}
}

export default PostpaidCustomerDetail;